// src/HomepageAlbums.js
import React, { useEffect, useState } from "react";
import {
  getFirestore,
  collection,
  query,
  onSnapshot,
  addDoc,
  updateDoc,
  doc,
} from "firebase/firestore";
import app from "./firebase";

export default function HomepageAlbums() {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newAlbum, setNewAlbum] = useState({
    title: "",
    order: 0,
    visible: true,
    badge: "",
  });

  const db = getFirestore(app);

  useEffect(() => {
    const q = query(collection(db, "homepage_albums"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const items = [];
      snapshot.forEach((doc) =>
        items.push({ id: doc.id, ...doc.data() })
      );
      // sortiranje po "order"
      items.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      setAlbums(items);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [db]);

  const addAlbum = async () => {
    if (!newAlbum.title) return;
    await addDoc(collection(db, "homepage_albums"), newAlbum);
    setNewAlbum({ title: "", order: 0, visible: true, badge: "" });
  };

  const updateAlbum = async (id, field, value) => {
    await updateDoc(doc(db, "homepage_albums", id), { [field]: value });
  };

  if (loading) return <p>Loading albums...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Homepage Albums</h2>

      {/* Forma za dodavanje */}
      <div style={{ marginBottom: 20, border: "1px solid #ccc", padding: 10 }}>
        <h4>Dodaj novi album</h4>
        <input
          type="text"
          placeholder="Naslov"
          value={newAlbum.title}
          onChange={(e) => setNewAlbum({ ...newAlbum, title: e.target.value })}
          style={{ marginRight: 10 }}
        />
        <input
          type="number"
          placeholder="Order"
          value={newAlbum.order}
          onChange={(e) =>
            setNewAlbum({ ...newAlbum, order: Number(e.target.value) })
          }
          style={{ width: 80, marginRight: 10 }}
        />
        <select
          value={newAlbum.visible}
          onChange={(e) =>
            setNewAlbum({ ...newAlbum, visible: e.target.value === "true" })
          }
          style={{ marginRight: 10 }}
        >
          <option value="true">Vidljiv</option>
          <option value="false">Sakriven</option>
        </select>
        <input
          type="text"
          placeholder="Badge (NEW/HOT)"
          value={newAlbum.badge}
          onChange={(e) => setNewAlbum({ ...newAlbum, badge: e.target.value })}
          style={{ marginRight: 10 }}
        />
        <button onClick={addAlbum}>Dodaj</button>
      </div>

      {/* Tabela sa albumima */}
      <table border="1" cellPadding="8" style={{ width: "100%", background: "#fff" }}>
        <thead>
          <tr>
            <th>Redosled</th>
            <th>Naslov</th>
            <th>Vidljiv</th>
            <th>Badge</th>
          </tr>
        </thead>
        <tbody>
          {albums.map((album) => (
            <tr key={album.id}>
              <td>
                <input
                  type="number"
                  value={album.order ?? 0}
                  onChange={(e) =>
                    updateAlbum(album.id, "order", Number(e.target.value))
                  }
                  style={{ width: 60 }}
                />
              </td>
              <td>
                <input
                  type="text"
                  value={album.title}
                  onChange={(e) =>
                    updateAlbum(album.id, "title", e.target.value)
                  }
                />
              </td>
              <td>
                <select
                  value={album.visible ? "true" : "false"}
                  onChange={(e) =>
                    updateAlbum(album.id, "visible", e.target.value === "true")
                  }
                >
                  <option value="true">Vidljiv</option>
                  <option value="false">Sakriven</option>
                </select>
              </td>
              <td>
                <input
                  type="text"
                  value={album.badge ?? ""}
                  onChange={(e) =>
                    updateAlbum(album.id, "badge", e.target.value)
                  }
                  placeholder="npr. HOT"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
